import {createStructuredSelector} from "reselect";
import {IDataProps, IExternalProps} from "ui/molecule/header/HeaderUI";
import {localizationSelector} from "ui/organism/App/selectors";

export default createStructuredSelector<IExternalProps, IDataProps>({
    localization: localizationSelector,
});
